
import Vue from 'vue'
import firebase from 'firebase/compat/app'
import { Venue } from '@/interfaces/venue'
import { showSnackbar } from '@/globalActions'

export default Vue.extend({
  name: 'Venues',
  data () {
    return {
      valid: false,
      loading: false,
      saving: false,
      dialog: {
        create: false,
        location: false
      },
      geoInput: '',
      geoInputValid: false,
      createRtmpKeyVisible: false,
      editRtmpKeyVisible: false,
      createData: {
        name: '',
        nameRules: [
          (v: string) => !!v || (this.$t('name-form-rule') as string)
        ],
        city: '',
        cityRules: [
          (v: string) => !!v || (this.$t('city-form-rule') as string)
        ],
        rtmpUri: '',
        rtmpKey: '',
        disabled: false
      },
      VenueData: {
        name: '',
        city: '',
        location: {
          latitude: 0,
          longitude: 0
        }
      },
      dialogData: {
        id: '',
        name: '',
        city: '',
        location: undefined as Venue['location'] | undefined,
        rtmpUri: '' as string | null,
        rtmpKey: '' as string | null
      } as Venue,
      items: {}
    }
  },
  mounted () {
    this.$store.dispatch('venues/fetchAndAdd')
  },
  methods: {
    hasRtmp (venue: Venue): boolean {
      return !!(venue && venue.rtmpUri && venue.rtmpKey)
    },
    setupVenueInputs () {
      if (this.geoInput && this.geoInput.includes(',')) {
        const geo = this.geoInput.split(',')
        if (!isNaN(parseFloat(geo[0])) && !isNaN(parseFloat(geo[1]))) {
          this.VenueData.location.latitude = parseFloat(geo[0])
          this.VenueData.location.longitude = parseFloat(geo[1])
          this.geoInputValid = true
        } else {
          alert(this.$t('geo-location-alert'))
          this.geoInputValid = false
        }
      } else {
        alert(this.$t('geo-location-not-right'))
      }
    },
    closeCreate (dialogCreate?: { value: boolean }) {
      if (dialogCreate) {
        dialogCreate.value = false
      }
      this.dialog.create = false
    },
    openDialog (document: Venue) {
      const loc = document.location as { latitude?: number | null; longitude?: number | null } | undefined
      this.dialogData = {
        id: document.id,
        name: document.name || '',
        city: document.city || '',
        location: loc
          ? {
            latitude: loc.latitude ?? null,
            longitude: loc.longitude ?? null
          }
          : undefined,
        rtmpUri: document.rtmpUri || '',
        rtmpKey: document.rtmpKey || ''
      }
      this.editRtmpKeyVisible = false
      this.dialog.location = true
    },
    async saveVenue () {
      if (!this.dialogData.id) {
        return
      }
      this.saving = true
      try {
        const payload: Record<string, unknown> = {
          id: this.dialogData.id,
          name: String(this.dialogData.name || '').trim(),
          city: String(this.dialogData.city || '').trim(),
          rtmpUri: String(this.dialogData.rtmpUri || '').trim() || null,
          rtmpKey: String(this.dialogData.rtmpKey || '').trim() || null
        }
        await this.$store.dispatch('venues/patch', payload)
        this.dialog.location = false
        showSnackbar(this.$t('venue-saved') as string, { color: 'success' })
      } catch (err: unknown) {
        console.error('saveVenue', err)
        const message = err instanceof Error ? err.message : String(err || '')
        showSnackbar(
          message || (this.$t('venue-save-failed') as string),
          { duration: 5000, color: 'danger' }
        )
      } finally {
        this.saving = false
      }
    },
    validate () {
      const form = this.$refs.venueForm as { validate: () => boolean } | undefined
      if (form && form.validate()) {
        this.loading = true
        const data: Record<string, unknown> = {
          name: this.createData.name,
          city: this.createData.city,
          location: {},
          rtmpUri: String(this.createData.rtmpUri || '').trim() || null,
          rtmpKey: String(this.createData.rtmpKey || '').trim() || null
        }
        if (this.VenueData.location.latitude !== 0 && this.geoInputValid) {
          const geoLocation = new firebase.firestore.GeoPoint(
            this.VenueData.location.latitude,
            this.VenueData.location.longitude
          )
          data.location = geoLocation
        }
        this.$store.dispatch('venues/set', data).then(() => {
          this.dialog.create = false
          this.createData.name = ''
          this.createData.city = ''
          this.createData.rtmpUri = ''
          this.createData.rtmpKey = ''
          this.geoInput = ''
          this.createRtmpKeyVisible = false
          this.loading = false
          showSnackbar(this.$t('venue-saved') as string, { color: 'success' })
        }).catch(() => {
          this.loading = false
        })
      }
    },
    unlink (id: string) {
      this.$store.dispatch('venues/delete', id)
    }
  }
})
